import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";

const initialState = {
  initialData: {
    "data": [
      {
        "deviceNetwork": {
          "defaultGateway": "192.168.1.254",
          "localIp": "192.168.1.10",
          "mgmtVlan": 1,
          "primaryDns": "8.8.8.8",
          "publicIp": "203.0.113.10",
          "sencondaryDns": "8.8.4.4",
          "subnetMask": "255.255.255.0",
          "uplinkDeviceMac": "BC:22:21:15:20:39",
          "uplinkDeviceName": "Gateway-Router"
        },
        "info": {
          "address": "123 Business Ave, Taipei",
          "cpuUtilization": 15.5,
          "deviceName": "SW-Core-01",
          "deviceTag": [
            { "tagId": "tag-01", "tagName": "Core" },
            { "tagId": "tag-02", "tagName": "Server-Room" }
          ],
          "deviceType": "switch",
          "firmwareVersion": "2.10.B05",
          "hardwareVersion": "A1",
          "linkStatus": "online",
          "localIpAddr": "192.168.1.10",
          "macAddress": "3C:33:32:14:A2:00",
          "memoryUtilization": 45.2,
          "modelName": "DMS-3130-30PS",
          "poePowerUsage": 245.8,
          "publicIpAddr": "203.0.113.10",
          "registrationState": "registered",
          "serialNumber": "D1KJ39DKS001",
          "siteName": "Main Office",
          "syncStatus": "synced",
          "timeZone": "Asia/Taipei",
          "uptime": 1735000000,
          "lastOfflineTime": 1734584000,
          "connectivityTimeline": [
            { "createdAt": 1735584000, "type": "DEVICE_ONLINE" }
          ],
          "client": 12,
          "id": "device-uuid-01",
        },
        "switchPorts": Array.from({ length: 30 }, (_, i) => ({
          "poePortClassifications": i < 24 ? 4 : 0,
          "poePortPower": i < 12 ? (Math.random() * 15).toFixed(1) : "0.0",
          "poePortStatus": i < 12 ? 1 : 0,
          "portAttriAdminState": 1,
          "portStaDuplex": 2,
          "portStaErrorState": "00",
          "portStaIndex": i + 1,
          "portStaIsUplink": i === 0 ? 1 : 0,
          "portStaMediaType": 1,
          "portStaSpeed": i < 24 ? 3 : 10,
          "portStaStatus": i < 15 ? 1 : 0
        })),
        "capabilities": {
          "ipv4Config": true,
          "ipv6Config": true,
          "portTypes": [...Array(24).fill(1), ...Array(6).fill(3)],
        },
      },
      {
        "deviceNetwork": {
          "defaultGateway": "192.168.1.254",
          "localIp": "192.168.1.50",
          "mgmtVlan": 1,
          "primaryDns": "8.8.8.8",
          "publicIp": "203.0.113.10",
          "subnetMask": "255.255.255.0",
          "uplinkDeviceMac": "3C:33:32:14:A2:00",
          "uplinkDeviceName": "SW-Core-01"
        },
        "info": {
          "deviceName": "AP-Lobby-Main",
          "deviceTag": [
            { "tagId": "tag-03", "tagName": "Lobby" }
          ],
          "deviceType": "ap",
          "firmwareVersion": "1.25.001",
          "hardwareVersion": "B1",
          "linkStatus": "online",
          "localIpAddr": "192.168.1.50",
          "macAddress": "00:7A:82:33:44:53",
          "memoryUtilization": 32.5,
          "cpuUtilization": 12.1,
          "modelName": "DAP-X2810",
          "poePowerUsage": 12.5,
          "publicIpAddr": null,
          "registrationState": "registered",
          "serialNumber": "AP99K2L10023",
          "siteName": "Main Office",
          "syncStatus": "synced",
          "timeZone": "Asia/Taipei",
          "uptime": 1735100000,
          "lastOfflineTime": null,
          "connectivityTimeline": null,
          "client": 65,
          "id": "device-uuid-02",
        },
        "apRadio": [
          { "band": "2", "channel": 1, "spectrum": "20MHz", "txPowerInPercent": 100 },
          { "band": "5", "channel": 36, "spectrum": "80MHz", "txPowerInPercent": 100 }
        ],
        "capabilities": {
          "env": "indoor",
          "radios": ["2", "5"],
          "radiosBandwidth": { "2": 20, "5": 80 },
          "radiosGen": { "2": 6, "5": 6 }
        }
      },
      {
        "deviceNetwork": {
          "defaultGateway": null,
          "localIp": "203.0.113.10",
          "mgmtVlan": 0,
          "subnetMask": "255.255.255.252",
        },
        "info": {
          "deviceName": "Gateway-Router",
          "deviceType": "router",
          "firmwareVersion": "3.50.T12",
          "hardwareVersion": "A1",
          "linkStatus": "online",
          "localIpAddr": "192.168.1.254",
          "macAddress": "BC:22:21:15:20:39",
          "modelName": "DBG-2000",
          "registrationState": "registered",
          "serialNumber": "RT88M1P90055",
          "siteName": "Main Office",
          "syncStatus": "synced",
          "uptime": 1735200000,
          "lastOfflineTime": 1734584000,
          "connectivityTimeline": null,
          "id": "device-uuid-03",
          "connectedClient": 285
        },
        "routerInternet": [
          {
            "name": "WAN1",
            "ipv4": { "type": "Static", "ipAddress": "203.0.113.10", "gateway": "203.0.113.9", "dns1": "8.8.8.8" }
          }
        ]
      },
      {
        "deviceNetwork": {
          "defaultGateway": "192.168.1.254",
          "localIp": "192.168.1.100",
          "mgmtVlan": 1,
          "primaryDns": "8.8.8.8",
          "publicIp": "203.0.113.10",
          "sencondaryDns": "8.8.4.4",
          "subnetMask": "255.255.255.0",
          "uplinkDeviceMac": "BC:22:21:15:20:39",
          "uplinkDeviceName": "Gateway-Router"
        },
        "info": {
          "deviceName": "Proxy-Device-01",
          "deviceType": "proxy",
          "firmwareVersion": "1.0.0",
          "hardwareVersion": "A1",
          "linkStatus": "online",
          "localIpAddr": "192.168.1.100",
          "macAddress": "00:11:22:33:44:55",
          "modelName": "Unity Proxy",
          "registrationState": "registered",
          "serialNumber": "PX88M1P90099",
          "siteName": "Main Office",
          "syncStatus": "synced",
          "uptime": 1735200000,
          "lastOfflineTime": null,
          "connectivityTimeline": null,
          "id": "device-uuid-04"
        },
        "capabilities": {
          "ipv4Config": true,
          "ipv6Config": true
        },
        "managedDevices": {}
      }
    ],
    "total": 4
  },
  selecterDevicesData: {
    data: [],
  },
  selecterDevicesDrawerData: {
    data: {},
  }
};

export const devicesSlice = createSlice({
  name: "devices",
  initialState,
  reducers: {
    setDevicesData: (state, action) => {
      if (action.payload.type === "all") {
        state.selecterDevicesData.data = cloneDeep(state.initialData.data.filter(item => item.info));
      }

      if (action.payload.type === "ap") {
        const filteredData = state.initialData.data.filter(item => item.info && item.info.deviceType === "ap");
        state.selecterDevicesData.data = filteredData;
      }

      if (action.payload.type === "switch") {
        const filteredData = state.initialData.data.filter(item => item.info && item.info.deviceType === "switch");
        state.selecterDevicesData.data = filteredData;
      }

      if (action.payload.type === "router") {
        const filteredData = state.initialData.data.filter(item => item.info && item.info.deviceType === "router");
        state.selecterDevicesData.data = filteredData;
      }

      if (action.payload.type === "proxy") {
        const filteredData = state.initialData.data.filter(item => item.info && item.info.deviceType === "proxy");
        state.selecterDevicesData.data = filteredData;
      }
    },
    setDevicesInventoryData: (state) => {
      state.selecterDevicesData.data = cloneDeep(state.initialData.data.filter(item => item.inventory));
    },
    updateDevicesSite: (state, action) => {
      state.initialData.data = action.payload;
    },
    setReMoveFromSite: (state, action) => {
      const { data } = action.payload;
      const deleteIds = data.map(item => item.deviceId);

      state.initialData.data = state.initialData.data.map(device =>
        deleteIds.includes(device.info.macAddress)
          ? {
            ...device,
            info: { ...device.info, siteName: null },
          }
          : device
      );
    },
    setDeleteDevice: (state, action) => {
      const { data } = action.payload;
      const deleteIds = data.map(item => item.deviceId);

      state.initialData.data = state.initialData.data.filter(device => {
        return !deleteIds.includes(device.info?.macAddress) && !deleteIds.includes(device.inventory?.macAddress);
      });
    },
    setDrawerContentData: (state, action) => {
      const { deviceId } = action.payload;
      const filteredData = state.initialData.data.find(item => item.info && item.info.macAddress === deviceId);
      state.selecterDevicesDrawerData.data = filteredData;
    }
  },
});

export const setMoveToSite = (payload) => (dispatch, getState) => {
  const state = getState();
  const siteList = state.scopeLevel.data.sites;
  const { siteId, deviceIds } = payload;
  const siteName = siteId ? siteList.find((s) => s.siteId === siteId).siteName : null;

  const updatedDevices = state.devices.initialData.data.map((device) => {
    const mac = device.info?.macAddress || device.inventory?.macAddress;
    if (deviceIds.includes(mac)) {
      if (device.info) {
        return { ...device, info: { ...device.info, siteName: siteName } };
      }
    }
    return device;
  });

  dispatch({ type: "devices/updateDevicesSite", payload: updatedDevices });
};

export const { setDevicesData, setReMoveFromSite, setDeleteDevice, setDevicesInventoryData, setDrawerContentData } = devicesSlice.actions;
export default devicesSlice.reducer;
